import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import AuthModal from '../auth/AuthModal';
import OtpModal from '../auth/OtpModal';

interface InteractionGuardProps {
  onAuthenticated: () => void;
  onCancel: () => void;
  requiresBilling?: boolean;
  actionName: string;
  hideSignInToggleAndCancel?: boolean; // Hide sign-in toggle and cancel button (for /lander-1)
}

export default function InteractionGuard({
  onAuthenticated,
  onCancel,
  actionName,
  hideSignInToggleAndCancel = false,
}: InteractionGuardProps) {
  const { isAuthenticated } = useAuth();
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [email, setEmail] = useState('');

  // If already authenticated, call onAuthenticated
  React.useEffect(() => {
    if (isAuthenticated) {
      onAuthenticated();
    }
  }, [isAuthenticated, onAuthenticated]);

  const handleEmailSent = (sentEmail: string) => {
    setEmail(sentEmail);
    setShowOtpModal(true);
  };

  const handleOtpVerified = () => {
    setShowOtpModal(false);
    // Auth state will update via onAuthStateChange, triggering onAuthenticated
  };

  const handleEditEmail = () => {
    setShowOtpModal(false);
    setEmail('');
  };

  if (isAuthenticated) {
    return null;
  }

  if (showOtpModal) {
    return (
      <OtpModal
        email={email}
        onClose={onCancel}
        onEditEmail={handleEditEmail}
        onVerified={handleOtpVerified}
      />
    );
  }

  return (
    <AuthModal
      onClose={onCancel}
      onEmailSent={handleEmailSent}
      actionName={actionName}
      hideSignInToggleAndCancel={hideSignInToggleAndCancel}
    />
  );
}

